import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAppBar,{class:['top-bar__app-bar py-0', !_vm.isDarkMode ? 'white' : ''],attrs:{"app":"","clipped-left":"","flat":"","height":"72"}},[_c(VAppBarNavIcon,{on:{"click":_vm.toggleDrawer}}),_c(VSpacer),_c('NotificationButton'),_c('TheProfileDropdown',{staticClass:"ml-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }